import { Fragment, type ReactNode } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { cn } from '@/lib/utils';

interface MetricItem {
  label: string;
  value: string | number;
}

interface MetricCardProps {
  title: ReactNode;
  metrics: MetricItem[];
  className?: string;
}

export function MetricCard({ title, metrics, className }: MetricCardProps) {
  return (
    <Card className={cn('flex h-full flex-col', className)}>
      <CardHeader className='pb-4'>
        <CardTitle className='text-base font-semibold'>{title}</CardTitle>
      </CardHeader>
      <CardContent className='flex flex-1 flex-col justify-center px-6'>
        <div className='flex flex-wrap items-stretch gap-6'>
          {metrics.map((metric, idx) => (
            <Fragment key={idx}>
              <div className='flex flex-col gap-1 min-w-[80px]'>
                <span className='text-sm font-medium text-muted-foreground'>
                  {metric.label}
                </span>
                <span className='text-3xl font-semibold leading-normal'>
                  {metric.value}
                </span>
              </div>
              {idx < metrics.length - 1 && (
                <Separator orientation='vertical' className='h-auto' />
              )}
            </Fragment>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
